import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import AdminModeSwitcher, { AdminMode } from './AdminModeSwitcher';
import NodeManager from './node/NodeManager';
import DeviceManager from './device/DeviceManager';
import KosaManager from './kosa/KosaManager';
import UserManager from './user/UserManager';
import TokenManager from './token/TokenManager';

export default function Admin() {
    const [mode, setMode] = useState(AdminMode.Structure);

    return (
        <Box sx={{ flexGrow: 1, bgcolor: 'background.default' }}>
            <Box sx={{ p: 4, maxWidth: 860, mx: 'auto' }}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                    Настройки администратора
                </Typography>
                <Typography variant="body2" color="text.secondary" mb={3}>
                    Настройка структуры предприятия, устройств, пользователей.
                </Typography>
                <AdminModeSwitcher value={mode} onChange={setMode} />
                <Box mt={3}>
                    {mode === AdminMode.Structure && <NodeManager />}
                    {mode === AdminMode.Devices && <DeviceManager />}
                    {mode === AdminMode.Sensors && <KosaManager />}
                    {mode === AdminMode.Users && <UserManager />}
                    {mode === AdminMode.Tokens && <TokenManager />}
                </Box>
            </Box>
        </Box>
    );
}
